


































































import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'
import { ResourceViewModel } from '@/business/resource/interfaces/resource-view-model'
import RespondecoResponsiveImage from '@/shared/components/respondeco-responsive-image.vue'
import RespondecoIcon from '@/shared/components/respondeco-icon.vue'

@Component({
  name: 'resource-item',
  components: { RespondecoIcon, RespondecoResponsiveImage, RespondecoLoadingIndicator },
})
export default class ResourceItem extends Vue {
  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly active!: boolean

  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly hideName!: boolean

  @Prop({
    type: Object,
  })
  public readonly item!: ResourceViewModel

  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly noActions!: boolean

  public dropdownIsOpen = false

  public get isActive(): boolean {
    return this.active || this.dropdownIsOpen
  }

  get showActions(): boolean {
    return this.noActions !== true
  }

  public handleDropdownHide(): void {
    this.dropdownIsOpen = false
  }

  public handleDropdownShow(): void {
    this.dropdownIsOpen = true
  }
}
